import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getSeo, seoTags } from "../seo";

const upsert = (selector, create) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
};

/** Met l'en-tête du document à jour à chaque changement de page. */
export const useSeo = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const { title, metas, canonical, jsonLd } = seoTags(getSeo(pathname));
    document.title = title;

    metas.forEach(({ name, property, content }) => {
      const attr = name ? "name" : "property";
      const key = name || property;
      const el = upsert(`meta[${attr}="${key}"]`, () => {
        const meta = document.createElement("meta");
        meta.setAttribute(attr, key);
        return meta;
      });
      el.setAttribute("content", content);
    });
    if (!metas.some((m) => m.property === "og:url")) {
      document.head.querySelector('meta[property="og:url"]')?.remove();
    }

    const link = document.head.querySelector('link[rel="canonical"]');
    if (canonical) {
      upsert('link[rel="canonical"]', () => {
        const el = document.createElement("link");
        el.rel = "canonical";
        return el;
      }).href = canonical;
    } else {
      link?.remove();
    }

    const script = document.getElementById("seo-jsonld");
    if (jsonLd) {
      upsert("#seo-jsonld", () => {
        const el = document.createElement("script");
        el.id = "seo-jsonld";
        el.type = "application/ld+json";
        return el;
      }).textContent = jsonLd;
    } else {
      script?.remove();
    }
  }, [pathname]);
};
